

























import {Component, Vue, Watch} from 'vue-property-decorator';
import Password from '../components/Password.vue';
import ErrorGroup from '../components/ErrorGroup.vue';
import Heading from '../components/Heading.vue';
import PasswordStrengthIndicator from '../components/PasswordStrengthIndicator.vue';
import {Action, State} from 'vuex-class';
import {passwordStrengthCopy, validatePassword} from '@/helpers/validate-password';

@Component({
  components: {
    Password,
    ErrorGroup,
    Heading,
    PasswordStrengthIndicator,
  },
})
export default class CreateAccount extends Vue {
  @State('email') public email?: string;
  @State('userCreated') public userCreated?: boolean;
  passwordStrengthCopy = passwordStrengthCopy;
  protected password: string = '';
  protected isPrestinePassword: boolean = true;
  protected isValidPassword: boolean = false;

  @Action('createAccount') protected createAccountAction: any;

  protected handleSubmit() {
    this.createAccountAction({email: this.email, password: this.password});
  }

  @Watch('password')
  private onModelChanged(value: string, oldValue: string) {
    this.isValidPassword = validatePassword(value);
    this.isPrestinePassword = false;
  }
}
